// Assistive Device Application
const application = 'adaim/assistive-device-applications/'
export const applicantList = application + 'list'
export const DemandCollectionList = application + 'demandlist'
export const applicantShow = application + 'show'
export const getPatientDetailsApi = application + 'patient-details'
export const deviceApplicatonStore = application + 'store'
export const deviceApplicatonUpdate = application + 'update'
export const applicantToggleStatus = application + 'toggle-status'
export const applicationRequestApproveApi = application + 'approve-device-application'
export const applicationRequestRejectApi = application + 'reject-device-application'

// psosk Demand
const psoskDemand = 'adaim/psosk-demand/'
export const psoskDemandStore = psoskDemand + 'store'
export const psoskDemandUpdate = psoskDemand + 'update'
export const psoskDemandList = psoskDemand + 'list'
export const psoskDemandShow = psoskDemand + 'show'

// Budget Prepare
const budgetPrepare = 'adaim/budget-prepare/'
export const assistiveDeviceData = budgetPrepare + 'assistive-device-data'
export const budgetPrepareStore = budgetPrepare + 'store'
export const budgetPrepareUpdate = budgetPrepare + 'update'
export const budgetPrepareList = budgetPrepare + 'list'
export const budgetPrepareShow = budgetPrepare + 'show'

// Purchase Order
const purchaseOrder = 'adaim/purchase-order/'
export const fundReciveData = purchaseOrder + 'fund-recive-data'
export const purchaseOrderStore = purchaseOrder + 'store'
export const purchaseOrderUpdate = purchaseOrder + 'update'
export const purchaseOrderList = purchaseOrder + 'list'
export const purchaseOrderShow = purchaseOrder + 'show'

// Fund Recieved
const fundRecieved = 'adaim/fund-recieved/'
// export const assistiveDeviceData = budgetPrepare + 'assistive-device-data'
// export const budgetPrepareStore = budgetPrepare + 'store'
// export const budgetPrepareUpdate = budgetPrepare + 'update'
export const fundRecievedList = fundRecieved + 'list'
export const fundRecievedListRetrive = fundRecieved + 'listnew'
export const fundRecievedListRetriveTwo = fundRecieved + 'listnewtwo'
export const fundRecievedStore = fundRecieved + 'store'
export const fundRecievedUpdate = fundRecieved + 'update'
// export const budgetPrepareShow = budgetPrepare + 'show'

// Distributed Purchase Oder Api
const distPurOrderBaseUrl = 'adaim/distributed-purchase-order/'
export const purchaseMemoList = distPurOrderBaseUrl + 'purchase-memo-no'
export const purchaseWiseSupplierInfo = distPurOrderBaseUrl + 'purchase-info'
export const assistiveDeviceWisePurchaseQty = distPurOrderBaseUrl + 'assistive-device-purchase-quantity'
export const purchaseMemoWiseDeviceName = distPurOrderBaseUrl + 'purchase-order-wise-assistive-device'
export const distPurOrderList = distPurOrderBaseUrl + 'list'
export const distPurOrderStore = distPurOrderBaseUrl + 'store'
export const distPurOrderUpdate = distPurOrderBaseUrl + 'update'
export const distPurOrderShow = distPurOrderBaseUrl + 'show'
export const distPurOrderChangeStatus = distPurOrderBaseUrl + 'change-status'
export const distPurOrderChallanNoList = distPurOrderBaseUrl + 'challan-list'

// Donation Recive
const donationReceive = 'adaim/donation-receive/'
export const donationReceiveStore = donationReceive + 'store'
export const donationReceiveUpdate = donationReceive + 'update'
export const donationReceiveList = donationReceive + 'list'
export const donationReceiveView = donationReceive + 'view'
export const donationReceiveToggleStatus = donationReceive + 'toggle-status'

// Chalan Wise Assistive Device
export const chalanWiseAssistiveDeviceName = 'adaim/recieve-against-purchase-order/list'
// Recieve Against Purchase Order
export const RecieveAgainstPurchaseOrderStore = 'adaim/recieve-against-purchase-order/store'
export const RecieveAgainstPurchaseOrderList = 'adaim/recieve-against-purchase-order/list'
export const RecieveAgainstPurchaseOrderDeviceList = 'adaim/recieve-against-purchase-order/device-list'
// Stock In
export const StockInStore = 'adaim/stock-in/store'
export const StockInList = 'adaim/stock-in/list'
export const StockInUpdate = 'adaim/stock-in/update'
// Stock Out Requisition
export const StockOutRequisitionStore = 'adaim/stock-out-requisition/store'
export const StockOutRequisitionList = 'adaim/stock-out-requisition/list'
export const StockOutRequisitionApproveList = 'adaim/stock-out-requisition/approvelist'
export const StockOutRequisitionUpdate = 'adaim/stock-out-requisition/update'
export const StockOutRequisitionApprove = 'adaim/stock-out-requisition/approve'
export const StockOutRequisitionDetails = 'adaim/stock-out-requisition/details'
export const StockOutRequisitionTotalStock = 'adaim/stock-out-requisition/totalstock'
// Bill Generate Order
export const BillGenerateStore = 'adaim/bill-generate/store'
export const BillGenerateList = 'adaim/bill-generate/list'
export const BillGenerateDeviceList = 'adaim/bill-generate/device-list'
